import { render, staticRenderFns } from "./DentistAutocomplete.vue?vue&type=template&id=7a85a627&"
import script from "./DentistAutocomplete.vue?vue&type=script&lang=js&"
export * from "./DentistAutocomplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports